











































































































































































































































































import Vue from 'vue';
import vuetify from 'vuetify/lib/framework';
import axios from 'axios';
const tradeApi = 'http://127.0.0.1:3005';
var vue;

function crypt(data: string, key: string, meth: string) {
    let dataOut = '';
    let dataIn;
    let hash;
    if (meth == '-u') {
        dataIn = Buffer.from(data, 'hex');
        hash = Buffer.from(key, 'utf-8');
        let ib = 0;
        let rb = false;
        let iv = -1;
        for (let i = 0; i < dataIn.length; i++) {
            if (ib == hash.length - 1) {
                rb = true;
            }
            if (ib == 0) {
                rb = false;
                iv = iv * -1;
            }

            if (dataIn[i] < hash[ib] * iv) {
                dataIn[i] = 256 - hash[ib] * iv + dataIn[i];
            } else {
                dataIn[i] = (dataIn[i] - hash[ib] * iv) % 256;
            }
            if (hash.length > 1) {
                if (!rb) {
                    ib++;
                } else {
                    ib--;
                }
            }
        }
        dataOut = dataIn.toString();
    } else if (meth == '-e') {
        dataIn = Buffer.from(data, 'utf-8');
        hash = Buffer.from(key, 'utf-8');
        let ib = 0;
        let rb = false;
        let iv = -1;
        for (let i = 0; i < dataIn.length; i++) {
            if (ib == hash.length - 1) {
                rb = true;
            }
            if (ib == 0) {
                rb = false;
                iv = iv * -1;
            }
            if (dataIn[i] + hash[ib] * iv < 0) {
                dataIn[i] = dataIn[i] + hash[ib] * iv + 256;
            } else {
                dataIn[i] = (dataIn[i] + hash[ib] * iv) % 256;
            }

            if (hash.length > 1) {
                if (!rb) {
                    ib++;
                } else {
                    ib--;
                }
            }
        }
        dataOut = dataIn.toString('hex');
    }

    return dataOut.toUpperCase();
}
async function login() {
    return new Promise((resolve, reject) => {
        try {
            const id = Date.now();
            const secret = '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q';
            const token = crypt(String(id), secret, '-e');
            const data = { token: token, id: id, secret: secret, solde: 10000 };
            axios
                .post(`${tradeApi}/userlogin/`, `data=${JSON.stringify(data)}`)
                .then((res) => {
                    resolve(res.data.data);
                })
                .catch((err) => {
                    const result = JSON.stringify(err);
                    const status = JSON.parse(result);
                    reject(status.status);
                });
        } catch (error) {
            reject(error);
        }
    });
}
export default Vue.extend({
    name: 'App',
    computed: {
        currLoc: () => {
            return vue.$route.path;
        },
    },
    watch: {
        nm(v) {
            this.$vuetify.theme.dark = v;
            window.localStorage.setItem('nm', v ? 'true' : 'false');
        },
    },
    beforeMount() {
        const token = window.localStorage.getItem('token');
        const id = window.localStorage.getItem('id');
        const useRealAcc = window.localStorage.getItem('useRealAcc');
        if (!id || !token) {
            this.loggedIn = false;
            setTimeout(() => {
                //window.location.reload();
            }, 500);
        } else {
            this.loggedIn = true;
        }
        if (useRealAcc) {
            this.useDemo = false;
        } else {
            this.useDemo = true;
        }
        this.loggedIn = true;
    },
    mounted() {
        vue = this;

        setTimeout(() => {
            this.isMounted = true;
        }, 2000);
    },
    methods: {
        changeAccount() {
            if (this.useDemo == true) {
                window.localStorage.setItem('useRealAcc', 'true');
            } else {
                window.localStorage.removeItem('useRealAcc');
            }
            this.drawer = false;
            window.location.reload();
        },
        toFixed(val: number, fract: number) {
            return Number(Number(val).toFixed(fract));
        },
        logout() {
            window.localStorage.clear();
            window.location.href = '/#/login';
        },
        order() {
            this.orderloading = true;
            const token = window.localStorage.getItem('token');
            const id = window.localStorage.getItem('id');
            if (!token || !id) {
                return;
            }
            let datas = {
                bill: String(Date.now()),
                userid: id,
                token: token,
                value: this.oderValue,
                mode: this.paymentMode,
            };
            axios
                .post(`${tradeApi}/createorder/${id}`, `data=${JSON.stringify(datas)}`)

                .then((result) => {
                    if (result.status == 200) {
                        this.notificationText = `Pour valider votre achat, vous allez être redirigé sur la page de ${
                            this.paymentMode == 0 ? 'Paypal©' : 'Stripe©'
                        }`;

                        this.redirect = `${result.data}`;

                        this.notification = true;
                        this.orderloading = false;
                    }
                });
        },
    },
    data: () => ({
        isMounted: false,
        nm:
            window.localStorage.getItem('nm') != null
                ? window.localStorage.getItem('nm') == 'true'
                    ? true
                    : false
                : true,
        useDemo: true,
        tradewins: false,
        solde: 0,
        demo: 0,
        loggedIn: false,
        is_admin: false,
        allow_admin: false,
        allow_trading: true,
        name: '',
        first_name: '',

        symbols: [] as any[],
        activeSymbole: 'btcusd',
        drawer: false,
        paymentMode: 0,
        notificationText: '',
        redirect: '',
        notification: false,
        orderloading: false,
        orderValidate: false,
        orderDial: false,
        oderValue: 10,
        orderRules: [(value: any) => !!value || 'Requise.', (value: any) => value >= 10 || '10 Euros minimum'],
        //
    }),
});
